import { ChronologicalData } from './chronological-data.interface';
import { DateFormatter } from '../date-formatter.class';
/**
 * It takes an array of objects that have a date and some data, and an array of
 * dates, and returns an array of the data that matches the dates
 * @param {ChronologicalData<T>[]} rawData - ChronologicalData<T>[]
 * @param {Date[]} dates - Date[] - An array of dates that you want to get data
 * for.
 * @returns {T[]} An array of data that is filtered by the dates.
 */
export const getDataByDates = <T>(
  rawData: ChronologicalData<T>[],
  dates: Date[],
  locale?: string
): T[] => {
  const data: T[] = [];
  const dayLabels = Array.from(
    new Set(
      dates.map(
        (date) => new DateFormatter(locale).getDayString(date) as string
      )
    )
  );

  dayLabels.forEach((label) => {
    const array = rawData
      .filter((raw) => {
        const rawLabel = new DateFormatter(locale).getDayString(
          raw.date
        ) as string;
        return rawLabel === label;
      })
      .map((_) => _.data);

    data.push(...array);
  });

  return data;
};
